import { createFileRoute } from '@tanstack/react-router';
import { CreateCompanyPage } from '@/pages/company/create/create-company.tsx';

export const Route = createFileRoute('/_auth/unternehmen/anlegen/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <CreateCompanyPage />;
}
